/** Last status log — API may return snake_case or camelCase */
export function resolveLastStatusLog(lead) {
  return lead?.last_status_log ?? lead?.lastStatusLog ?? null;
}

/** Current lead status label for list / detail chips */
export function resolveLeadStatusName(lead) {
  if (!lead) return '';
  const log = resolveLastStatusLog(lead);
  return (
    log?.status?.name ??
    lead.status?.status?.name ??
    lead.status?.name ??
    lead.status_name ??
    ''
  );
}

/** Current lead status id (same fallbacks as list / status dialog) */
export function resolveLeadStatusId(lead) {
  if (!lead) return '';
  const log = resolveLastStatusLog(lead);
  const raw =
    log?.status?.id ??
    lead.status?.status?.id ??
    lead.status?.id ??
    lead.status_id;
  if (raw === undefined || raw === null || raw === '') return '';
  return raw;
}

export function idsEqual(a, b) {
  return a != null && b != null && a !== '' && b !== '' && String(a) === String(b);
}

/** Align stored id with option list (number vs string) */
export function matchOptionId(options, rawId) {
  if (rawId === '' || rawId == null) return '';
  const found = (options || []).find((o) => idsEqual(o.id, rawId));
  return found ? found.id : rawId;
}

export function findOptionById(options, id) {
  if (id === '' || id == null) return null;
  return (options || []).find((o) => idsEqual(o.id, id)) || null;
}

export function mergeLookupOption(options, entity) {
  if (!entity || entity.id == null || entity.id === '') return options || [];
  const list = options || [];
  if (list.some((o) => idsEqual(o.id, entity.id))) return list;
  return [...list, { id: entity.id, name: entity.name || String(entity.id) }];
}

function mergeAssigneeOptions(options, assignees) {
  if (!Array.isArray(assignees) || assignees.length === 0) return options || [];
  let list = options || [];
  assignees.forEach((a) => {
    const id = a?.uuid ?? a?.id;
    if (!id) return;
    if (list.some((o) => idsEqual(o.id, id))) return;
    list = [
      ...list,
      {
        id,
        name: a.name || a.fullName || a.username || String(id),
        role: a.roles?.[0]?.name || a.role || '',
      },
    ];
  });
  return list;
}

/** Ensure Autocomplete option lists include entities returned only on the lead payload */
export function enrichSelectOptionsFromLead(lead, lists) {
  const log = resolveLastStatusLog(lead);
  const statusEntity = log?.status ?? lead.status?.status ?? lead.status;
  return {
    statusOptions: mergeLookupOption(lists.statusOptions, statusEntity),
    sourceOptions: mergeLookupOption(lists.sourceOptions, lead.source),
    brandOptions: mergeLookupOption(lists.brandOptions, lead.brand),
    countryOptions: mergeLookupOption(lists.countryOptions, lead.country),
    companyOptions: mergeLookupOption(lists.companyOptions, lead.company),
    frontSellerOptions: mergeAssigneeOptions(lists.frontSellerOptions, lead.assignees),
  };
}
